var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.89648,
    y: 3.89655,
    width: 34.2069,
    height: 34.2069,
    rx: 9,
    fill: "#FA9418",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_3215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5767 30.1514C22.5767 30.1514 32.6627 30.8338 30.0163 27.6493C27.3698 24.4648 25.1676 26.3035 25.1676 26.3035L22.5767 30.1514Z",
    fill: "#E51E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0795 31.5001C22.2129 31.5001 19.089 31.0135 18.5561 30.9386C14.6237 30.2835 12.2532 28.6926 11.4815 26.222C9.60714 20.1578 18.5928 11.099 18.9787 10.7247C19.2911 10.4252 19.7689 10.4252 20.0629 10.7434C20.3569 11.0616 20.3569 11.5482 20.0445 11.8477C17.6373 14.2621 11.6285 21.4867 12.9515 25.7541C13.5212 27.607 15.5057 28.8236 18.795 29.3851C19.4381 29.4787 20.4304 29.6284 21.5697 29.722C21.9005 28.7113 22.7641 26.8584 24.7854 25.6605C27.0089 24.3316 28.4973 24.837 29.1956 25.2675C30.1879 25.8851 30.8127 27.0643 30.7575 28.2996C30.7208 29.4226 30.1328 30.3771 29.214 30.845C28.2768 31.3316 26.7333 31.5001 25.0795 31.5001ZM23.1684 29.853C25.3 29.9841 27.5234 29.9653 28.5341 29.46C29.1221 29.1605 29.214 28.5242 29.2324 28.2621C29.2507 27.5883 28.9384 26.952 28.4055 26.6338C27.7072 26.2033 26.7149 26.353 25.5756 27.0268C24.1974 27.8316 23.4991 29.0482 23.1684 29.853Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_3215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5517,
    height: 21,
    fill: "white",
    transform: "translate(11.2241 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/logoicon.6633146da64741f8cbe44fa124176f5d.svg";
export { ForwardRef as ReactComponent };